/* eslint-disable */
import React, { Component } from 'react';
import instance from "./axios-instance";
import Systems from "./SystemFunction";
import { t } from './i18n';

// ===== Asset URLs copied from the live example (aesexy.click) =====
const A = 'https://asset.cloudigame.co/build/admin/img/wt_theme/ezl/';
// rank position badge
const BADGE = (r) => {
    if (r === 1) return A + 'ic-rank-win-top-01.png';
    if (r === 2) return A + 'ic-rank-second-01.png';
    if (r === 3) return A + 'ic-rank-third-01.png';
    if (r >= 4 && r <= 10) return A + 'ic-rank-' + r + '.png';
    return null; // 11+ => number text
};
// reward highlight (trophy) icon — only top 3
const HILITE = { 1: A + 'ic-rank-win-top-02.png', 2: A + 'ic-rank-win-second-02.png', 3: A + 'ic-rank-win-third-02.png' };
// reward money icon
const MONEY = (r) => A + 'ic-rank-reward-' + (r <= 3 ? r : 4) + '.png';
// default tier avatar
const AVATAR = A + 'profile_icon_level_06.png';
// reward type tab icons
const TAB_WIN_IC = 'https://aesexy.click/build/web/ezl-ae-sexy/img/ranking-board-win-ic.png';
const TAB_CREDIT_IC = 'https://aesexy.click/build/web/ezl-ae-sexy/img/ranking-board-credit-ic.png';

// prize amount per rank (mirrors example tiers)
function prizeText(r) {
    if (r === 1) return '30K';
    if (r === 2) return '10K';
    if (r === 3) return '5.5K';
    if (r >= 4 && r <= 10) return '3.5K';
    if (r >= 11 && r <= 20) return '2K';
    return '1K';
}

class Toprank extends Component {
    get lang() { return localStorage.getItem('lang') || 'th'; }
    constructor(props) {
        super(props);
        this.state = { rankList: [], loading: true, board: 'win' };
    }
    async componentDidMount() { await this.loadTopRank(); }

    loadTopRank = async () => {
        this.setState({ loading: true });
        try {
            const res = await instance.post("/api/v1/getranking", { System: Systems });
            if (res.data.status === 200) this.setState({ rankList: res.data.message || [], loading: false });
            else this.setState({ rankList: [], loading: false });
        } catch (err) { this.setState({ rankList: [], loading: false }); }
    }

    mask(name) {
        if (!name) return "***";
        if (name.length <= 4) return name.substring(0, 3) + "****";
        return name.substring(0, 3) + "****";
    }

    itemClass(r) {
        if (r === 1) return '-top-item';
        if (r === 2) return '-second-item';
        if (r === 3) return '-third-item';
        if (r >= 4 && r <= 10) return '-forth-to-ten-item';
        return '-small-item';
    }

    renderItem(item, idx) {
        const r = idx + 1;
        const badge = BADGE(r);
        const tier = item.name || item.tier || '';
        const value = Number(item.win || item.Winner || item.winner || item.credit || 0).toLocaleString();
        return (
            <div key={idx} className={"x-ranking-item-full-size-container " + this.itemClass(r)}>
                <div className="-position-wrapper animated fadeInLeft">
                    {badge
                        ? <img alt="rank" className="-ic -position-img" width={70} height={70} src={badge} />
                        : <span className="-text">{r}</span>}
                </div>
                <div className="-profile-wrapper animated fadeInLeft">
                    <img src={AVATAR} className="-group-img" alt="profile" width={100} height={100} />
                    <div className="-profile-info-wrapper">
                        <span className="-phone-number">{this.mask(item.playerid || item.username)}</span>
                        {tier ? <span className="-group-title">{tier}</span> : null}
                    </div>
                </div>
                <div className="-result-wrapper">
                    <div className="-value-wrapper">
                        <span className="-value">{value}</span>
                    </div>
                </div>
                <div className="-reward-wrapper">
                    {HILITE[r] ? <img alt="trophy" className="-ic -highlight" width={50} height={50} src={HILITE[r]} /> : null}
                    <img alt="reward" className="-ic" width={50} height={50} src={MONEY(r)} />
                    <span className="-reward-text">{prizeText(r)}</span>
                </div>
            </div>
        );
    }

    render() {
        const lang = this.lang;
        const { rankList, loading, board } = this.state;
        return (
            <div className="container p-0 x-margin-top-v3">
                <div className="row m-0 border-shadow-title">
                    <div className="col-12 p-0 col-sm-10 col-md-9 col-lg-8 col-xl-8 mx-auto my-auto text-white-v1">
                        <div className="x-rankpage">

                            {/* title bar */}
                            <div className="text-center bg-title-web">
                                <div className="text-title text-white-v1 text-center">
                                    <div className="d-flex justify-content-between align-items-center p-2">
                                        <a role="button" href="/" style={{ cursor: 'pointer' }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width={25} height={25} fill="currentColor" className="bi bi-arrow-left-circle text-white" viewBox="0 0 16 16">
                                                <path fillRule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z" />
                                            </svg>
                                        </a>
                                        <h5 className="m-0">{t(lang, 'toprank_title')}</h5>
                                        <button onClick={this.loadTopRank} style={{ background: "none", border: "none", cursor: "pointer", width: 25 }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="currentColor" className="bi bi-arrow-clockwise text-white-v1" viewBox="0 0 16 16">
                                                <path fillRule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z" />
                                                <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
                                            </svg>
                                        </button>
                                    </div>
                                    <hr className="mt-0" />
                                </div>
                            </div>

                            {/* reward-type tabs */}
                            <ul className="nav -rank-board-tabs">
                                <li className={"nav-item -board-win"}>
                                    <a role="button" onClick={() => this.setState({ board: 'win' })} className={"nav-link -board-win " + (board === 'win' ? '-active' : '')}>
                                        <img alt="win board" className="-ic" width={40} height={40} src={TAB_WIN_IC} />
                                        <span className="-text">คาสิโน <span className="-behind">{t(lang, 'rank_tab_win')}</span></span>
                                    </a>
                                </li>
                                <li className={"nav-item -board-credit"}>
                                    <a role="button" onClick={() => this.setState({ board: 'credit' })} className={"nav-link -board-credit " + (board === 'credit' ? '-active' : '')}>
                                        <img alt="credit board" className="-ic" width={40} height={40} src={TAB_CREDIT_IC} />
                                        <span className="-text">คาสิโน <span className="-behind">{t(lang, 'rank_tab_credit')}</span></span>
                                    </a>
                                </li>
                            </ul>

                            {/* round tab */}
                            <div className="-rank-round-tabs">
                                <div className="-btn -active">{t(lang, 'rank_round_current')}</div>
                            </div>

                            {/* heading columns */}
                            <div className="x-ranking-heading-column-wrapper">
                                <div className="-column-wrapper -position"><span className="-text">{t(lang, 'rank_col')}</span></div>
                                <div className="-column-wrapper -profile"><span className="-text">{t(lang, 'username_col')}</span></div>
                                <div className="-column-wrapper -result"><span className="-text">{t(lang, 'rank_winamount')}</span></div>
                                <div className="-column-wrapper -reward"><span className="-text">{t(lang, 'rank_prize')}</span></div>
                            </div>

                            {/* list */}
                            {loading ? (
                                <div className="text-center py-5"><div className="spinner-border text-light" role="status" /><p className="mt-2 text-white-v1">{t(lang, 'loading')}</p></div>
                            ) : rankList.length === 0 ? (
                                <div className="text-center py-5"><div style={{ fontSize: 48 }}>🏆</div><p className="text-white-v1 mt-2">{t(lang, 'no_data')}</p></div>
                            ) : (
                                <div className="x-rank-list">
                                    {rankList.map((item, idx) => this.renderItem(item, idx))}
                                </div>
                            )}

                            <div style={{ height: 20 }} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Toprank;
